import { postJSON } from 'common/services/api'
import { useMutation, useQueryClient } from 'react-query'
import {
  MAR_CHART_QUERY_KEY,
  MEDICATION_SCHEDULE_PATTERN_PAUSE_URL,
  MEDICATION_SCHEDULE_PATTERN_QUERY_KEY,
  MEDICATION_SCHEDULE_PATTERNS_QUERY_KEY,
  STOCK_LOGS_QUERY_KEY
} from './queryConstants'

type UseMedicationSchedulePatternPauseReturn = {
  pauseMedicationSchedulePattern: (reason: string) => Promise<void>
  isPausingMedicationSchedulePattern: boolean
}

export type UseMedicationSchedulePatternPauseProps = {
  medicationId: string
  onSuccess?: () => void
  onError?: () => void
}

const useMedicationSchedulePatternPause = ({
  medicationId,
  onSuccess,
  onError
}: UseMedicationSchedulePatternPauseProps): UseMedicationSchedulePatternPauseReturn => {
  const queryClient = useQueryClient()

  const pauseMedicationSchedulePatternFunction = async (
    reason: string
  ): Promise<unknown> => {
    return postJSON({
      url: MEDICATION_SCHEDULE_PATTERN_PAUSE_URL.replace('{id}', medicationId),
      method: 'PUT',
      json: {
        reason
      }
    })
  }

  const {
    mutateAsync: pauseMedicationSchedulePatternMutation,
    isLoading: isPausingMedicationSchedulePattern
  } = useMutation<unknown, unknown, string, unknown>(
    [MEDICATION_SCHEDULE_PATTERN_QUERY_KEY],
    pauseMedicationSchedulePatternFunction,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([MEDICATION_SCHEDULE_PATTERNS_QUERY_KEY])
        queryClient.invalidateQueries([MEDICATION_SCHEDULE_PATTERN_QUERY_KEY])
        queryClient.invalidateQueries([MAR_CHART_QUERY_KEY])
        queryClient.invalidateQueries([STOCK_LOGS_QUERY_KEY])
        onSuccess?.()
      },
      onError: () => {
        onError?.()
      }
    }
  )

  const pauseMedicationSchedulePattern = async (
    reason: string
  ): Promise<void> => {
    await pauseMedicationSchedulePatternMutation(reason)
  }

  return {
    pauseMedicationSchedulePattern,
    isPausingMedicationSchedulePattern
  }
}

export default useMedicationSchedulePatternPause
